export default __webpack_public_path__ + "static/media/miaosha.c8172f6e.png";